import styles from './Merchant.module.scss';

import cx from 'classnames';
import React, { HTMLAttributes, FC } from 'react';

import type { Subject } from 'api/contentful/contentTypes.cloverdotcom';
import { FlatEntry } from 'services/cms/flattenContentful';
import { TextV2 } from 'components/TextV2/TextV2';
import { Image } from 'components/Image/Image';
import { RichBlurb } from 'components/RichBlurb/RichBlurb';

interface IMerchantProps extends HTMLAttributes<HTMLDivElement> {
  entry?: FlatEntry<Subject>;
  iShowcase?: boolean;
}

export const Merchant: FC<IMerchantProps> = ({ entry, className, iShowcase, ...props }) => {
  if (!entry) return null;

  const { image, title, subTitle, blurb, richBlurb } = entry;

  return (
    <div className={cx(className, styles.merchant, iShowcase && styles.isShowcase)} {...props}>
      {image && image.file?.url && (
        <div className={styles.logoWrap}>
          <Image src={image.file.url} alt={image.title} className={styles.logo} aria-hidden />
        </div>
      )}
      <figcaption className={styles.names}>
        <TextV2 variant="modern-body-medium" value={title} tagName="p" />
        <TextV2 variant="modern-body" value={subTitle} tagName="p" className={styles.subTitle} />
        <TextV2 variant="modern-legal" value={blurb} isMarkdown tagName="div" className={styles.legal} />
        <RichBlurb document={richBlurb} textVariant="modern-legal" className={styles.legal} noMarginGap />
      </figcaption>
    </div>
  );
};
